<div>
    <template v-if="processCounterLoading">
        <span class="vl-loader" aria-busy="true" /> Loading {{processCounterText}}
    </template>
    <template v-else>
        <router-link protect :to="{ name: adminProcessDetailRouteName, params: { type: processDetailType } }"
                     :class="processCounterCssClass(processCounter)">
            <vl-icon :icon="processCounterIcon(processCounter)" mod-large />
            <span v-if="processCounter > 0">{{processCounter}}&nbsp;</span>{{processCounterText}}
        </router-link>
    </template>
</div>
